import { useState } from "react";
import axios from "axios";

function AdminLogin() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {

    e.preventDefault();

    try {

      const res = await axios.post(
        "http://localhost:5000/api/auth/login",
        {
          email,
          password,
        }
      );

      // SAVE TOKEN
      localStorage.setItem("token", res.data.token);

      alert("Login successful");

      window.location.href = "/admin/dashboard";

    } catch (error) {

      console.log(error);

      alert("Invalid email or password");

    }
  };

  return (
    <section className="min-h-screen bg-[#F5F7FA] flex items-center justify-center px-6">

      <div className="bg-white w-full max-w-md p-10 rounded-[32px] shadow-2xl border border-gray-100">

        {/* SMALL LABEL */}
        <p className="uppercase tracking-[5px] text-yellow-600 font-semibold text-sm mb-4 text-center">
          GATI & CO. CMS
        </p>

        {/* HEADING */}
        <h1 className="text-4xl font-bold text-[#0B1C39] text-center mb-8">
          Admin Login
        </h1>

        {/* FORM */}
        <form onSubmit={handleLogin} className="space-y-6">

          {/* EMAIL */}
          <div>

            <label className="block mb-2 text-gray-700 font-medium">
              Email
            </label>

            <input
              type="email"
              placeholder="Enter admin email"
              className="w-full border border-gray-300 rounded-2xl px-5 py-4 outline-none focus:border-[#0B3D91] transition"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

          </div>

          {/* PASSWORD */}
          <div>

            <label className="block mb-2 text-gray-700 font-medium">
              Password
            </label>

            <input
              type="password"
              placeholder="Enter password"
              className="w-full border border-gray-300 rounded-2xl px-5 py-4 outline-none focus:border-[#0B3D91] transition"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="w-full bg-[#0B3D91] text-white py-4 rounded-2xl font-semibold hover:bg-[#092c6b] transition duration-300"
          >
            Login
          </button>

        </form>

      </div>

    </section>
  );
}

export default AdminLogin;